import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { InputText } from "primereact/inputtext";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import toast from "react-hot-toast";
import Loader from "../components/Loader";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Grid,
  FormHelperText,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox
} from "@material-ui/core";
import { MdEdit } from "react-icons/md";
import WarehouseMasterService from "../services/WarehouseMasterService";
import DistributorMasterService from "../services/DistributorMasterService";

const DistributorMaster = ({ isLoggedIn }) => {
  const warehouseMasterService = new WarehouseMasterService();
  const distributorMasterService = new DistributorMasterService();
  const [tableRequest, setTableRequest] = useState({
    IsActive: "1",
    PageNo: 1,
    First: 1,
    SearchValue: "",
    PageSize: 10,
    SortColumn: "CreatedDt",
    SortOrder: "DESC",
    ProductId: 0,
    WareHouseId: 0,
    UserId: sessionStorage.getItem("userId"),
    FromDate: "",
    ToDate: "",
    UserType: 0,
    IsAccepted: false,
    IsWareHouse: true,
    isAdmin: false,
    Prefix: "",
    isPreprinted: false,
    Qty: 0
  });
  const [state, setStatee] = useState({
    first: 0,
    sales: [],
    loading: true,
    datasource: [],
    allData: [],
    globalFilter: "",
    emptyMessage: "No Data found",
    rows: 10,
    totalRecords: 0,
    FromDate: new Date(),
    ToDate: new Date(),
    sortOrder: "",
    shippersData: []
  });
  const [formData, setFormData] = useState({
    SAPCustomerCode: "",
    distributorName: "",
    email: "",
    MobNo: "",
    password: "",
    Cpassword: "",
    country: "",
    state: "",
    city: "",
    address1: "",
    address2: "",
    pincode: "",
    lat: "",
    long: "",
    IsActive: true
  });
  const [states, setState] = useState([]);
  const [cities, setCity] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const navigate = useNavigate();
  const [showDialog, setShowDialog] = useState(false);
  const [formErrors, setFormErrors] = useState({
    SAPCustomerCode: "",
    distributorName: "",
    email: "",
    MobNo: "",
    password: "",
    Cpassword: "",
    country: "",
    state: "",
    city: "",
    address1: "",
    address2: "",
    pincode: "",
    lat: "",
    long: ""
  });

  const openDialog = (isAdd) => {
    if (isAdd) {
      setShowDialog(true);
      setSelectedRow(null);
    } else {
      setShowDialog(true);
    }
  };

  const handleButtonClick = (row) => {
    const editMode = () => {
      setSelectedRow(row);
      GetStates(row.country);
      GetCities(row.state);
      setFormData({
        distributorName: row.distributorName || "",
        email: row.email || "",
        MobNo: row.mobileNo || "",
        password: row.password || "",
        Cpassword: row.password || "",
        location: row.city || "",
        IsActive: row.isActive || false,
        SAPCustomerCode: row.sapCustomerCode || "",
        country: row.country || "",
        state: row.state || "",
        city: row.city || "",
        address1: row.address1 || "",
        address2: row.address2 || "",
        pincode: row.pincode || "",
        lat: row.lat || "",
        long: row.long || ""
      });
      if (row) {
        openDialog(false); // Edit action
      } else {
        openDialog(true); // Add action
      }
    };
    return (
      <Button
        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-2 rounded text-sm hover:bg-blue-700 hover:text-white cursor-pointer"
        onClick={editMode}
      >
        <MdEdit />
      </Button>
    );
  };

  const handleFormChange = (event) => {
    const { name, value, checked, type } = event.target;
    if (name === "country") {
      GetStates(value);
    }
    if (name === "state") {
      GetCities(value);
    }
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: type === "checkbox" ? checked : value
    }));
    validateForm(name, value);
  };

  const validateForm = (name, value) => {
    const errors = { ...formErrors };
    let IsValid = true;
    switch (name) {
      case "SAPCustomerCode":
        if (value.length < 1) {
          IsValid = false;
          errors.SAPCustomerCode = "Please enter SAP customer code.";
        } else errors.SAPCustomerCode = "";
        break;
      case "distributorName":
        if (value.length < 1) {
          IsValid = false;
          errors.distributorName = "Please enter distributor name.";
        } else errors.distributorName = "";
        break;
      case "email":
        if (value.length < 1) {
          IsValid = false;
          errors.email = "Please enter email-id.";
        } else if (value.length >= 1) {
          if (!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
            IsValid = false;
            errors.email = "Please enter valid email-id.";
          } else errors.email = "";
        } else errors.email = "";
        break;
      case "MobNo":
        if (value.length < 1) {
          IsValid = false;
          errors.MobNo = "Please enter mobile no.";
        } else if (value.length >= 1) {
          if (!value.match(/^[6-9]\d{9}$/)) {
            IsValid = false;
            errors.MobNo = "Please enter valid mobile no.";
          } else errors.MobNo = "";
        } else errors.MobNo = "";
        break;
      case "password":
        if (!value && value.length < 1) {
          IsValid = false;
          errors.password = "Please enter password.";
        } else if (!value.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{4,20}$/)) {
          IsValid = false;
          errors.password =
            "Password should be minimum 4 characters long, 1 uppercase & 1 lowercase character with 1 number.";
        } else if (
          value.length >= 1 &&
          formData.Cpassword.length >= 1
        ) {
          errors.password = "";
          errors.Cpassword = "";
          if (value !== formData.Cpassword) {
            IsValid = false;
            errors.password = "Password does not match";
          } else errors.password = "";
        } else errors.password = "";
        break;
      case "Cpassword":
        if (!value && value.length < 1) {
          IsValid = false;
          errors.Cpassword = "Please enter confirm password.";
        } else if (value.length >= 1 && formData.password.length >= 1) {
          errors.password = "";
          errors.Cpassword = "";
          if (value !== formData.password) {
            IsValid = false;
            errors.Cpassword =
              "New password and Confirm password should be same.";
          } else errors.Cpassword = "";
        } else errors.Cpassword = "";
        break;
      case "country":
        if (value.length < 1) {
          IsValid = false;
          errors.country = "Country is required.";
        } else errors.country = "";
        break;
      case "state":
        if (value.length < 1) {
          IsValid = false;
          errors.state = "State is required.";
        } else errors.state = "";
        break;
      case "city":
        if (value.length < 1) {
          IsValid = false;
          errors.city = "City is required.";
        } else errors.city = "";
        break;
      case "address1":
        if (value.length < 1) {
          IsValid = false;
          errors.address1 = "Address is required.";
        } else errors.address1 = "";
        break;
      case "address2":
        if (value.length < 1) {
          IsValid = false;
          errors.address2 = "Address is required.";
        } else errors.address2 = "";
        break;
      case "pincode":
        if (value.length !== 6 || !/^\d{6}$/.test(value)) {
          IsValid = false;
          errors.pincode = "Please enter a valid 6-digit pincode for India.";
        } else errors.pincode = "";
        break;
      default:
        break;
    }

    setFormErrors(errors);
    return IsValid;
  };

  function GetStates(Ccode) {
    warehouseMasterService
      .GetStates(Ccode)
      .then((response) => {
        const data = response.responseData;
        setState(data);
      })
      .catch((error) => {
        console.error("API request failed:", error);
      });
  }

  function GetCities(StateId) {
    warehouseMasterService
      .GetCities(StateId)
      .then((response) => {
        const data = response.responseData;
        setCity(data);
      })
      .catch((error) => {
        console.error("API request failed:", error);
      });
  }

  const closeDialog = () => {
    setShowDialog(false);
    GetDistributors();
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    let isfrmvalid = true;
    let checkerror = { ...formErrors };

    Object.entries(formData).forEach(([key, value]) => {
      if (key !== "lat" && key !== "long") { // Skip lat and long validation
        const valid = validateForm(key, value);
        if (!valid) {
          isfrmvalid = false;
        }
      }
    });

    if (isfrmvalid) {
      if (selectedRow) {
        // Editing existing user
        try {
          setStatee((prevData) => ({
            ...prevData,
            loading: true
          }));
          const userData = {
            UserId: selectedRow.id,
            SAPCustomerCode: formData.SAPCustomerCode,
            DistributorName: formData.distributorName,
            email: formData.email,
            MobileNo: formData.MobNo,
            password: formData.password,
            Cpassword: formData.Cpassword,
            Country: formData.country,
            State: formData.state,
            City: formData.city,
            Address1: formData.address1,
            Address2: formData.address2,
            Pincode: formData.pincode,
            lat: formData.lat,
            long: formData.long,
            IsActive: formData.IsActive
          };

          distributorMasterService
            .CreateUpdateDistributor(userData)
            .then((response) => {
              setStatee((prevData) => ({
                ...prevData,
                loading: false
              }));
              if (response.responseCode === "200") {
                toast.success("Distributor Updated Successfully!");
                setFormData({
                  SAPCustomerCode: "",
                  distributorName: "",
                  email: "",
                  MobNo: "",
                  password: "",
                  Cpassword: "",
                  country: "",
                  state: "",
                  city: "",
                  address1: "",
                  address2: "",
                  pincode: "",
                  lat: "",
                  long: "",
                  IsActive: true
                });
                setSelectedRow(null);
                setShowDialog(false);
                GetDistributors();
              } else if (response.responseCode === "400") {
                toast.error(response.responseMessage);
              }
            });
        } catch (error) {
          setStatee((prevData) => ({
            ...prevData,
            loading: false
          }));
          console.error("User Update failed:", error);
          toast.error(error.message);
        }
      } else {
        // Creating new user
        try {
          setStatee((prevData) => ({
            ...prevData,
            loading: true
          }));
          const FormDATA = {
            SAPCustomerCode: formData.SAPCustomerCode,
            DistributorName: formData.distributorName,
            email: formData.email,
            MobileNo: formData.MobNo,
            password: formData.password,
            Cpassword: formData.Cpassword,
            Country: formData.country,
            State: formData.state,
            City: formData.city,
            Address1: formData.address1,
            Address2: formData.address2,
            Pincode: formData.pincode,
            lat: formData.lat,
            long: formData.long,
            IsActive: formData.IsActive
          };

          distributorMasterService
            .CreateUpdateDistributor(FormDATA)
            .then((response) => {
              setStatee((prevData) => ({
                ...prevData,
                loading: false
              }));
              if (response.responseCode === "200") {
                toast.success("Distributor created successfully!");
                setFormData({
                  SAPCustomerCode: "",
                  distributorName: "",
                  email: "",
                  MobNo: "",
                  password: "",
                  Cpassword: "",
                  country: "",
                  state: "",
                  city: "",
                  address1: "",
                  address2: "",
                  pincode: "",
                  lat: "",
                  long: "",
                  IsActive: false
                });
              } else if (response.responseCode === "400") {
                toast.error(response.responseMessage);
              }
            });
        } catch (error) {
          setStatee((prevData) => ({
            ...prevData,
            loading: false
          }));
          console.error("Distributor Creation failed:", error);
          toast.error(error.message);
        }
      }
      closeDialog();
      GetDistributors();
    }
  };

  useEffect(() => {
    const storedToken = sessionStorage.getItem("token");
    if (storedToken) {
      isLoggedIn(true);
      Promise.all([GetDistributors()])
        .then(() => {
          setStatee((prevData) => ({
            ...prevData,
            loading: false
          }));
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setStatee((prevData) => ({
            ...prevData,
            loading: false
          }));
        });
    } else {
      isLoggedIn(false);
      navigate("/login");
    }
    setTimeout(() => {
      setStatee((prevData) => ({
        ...prevData,
        loading: false
      }));
    }, 1000);
  }, [isLoggedIn, navigate]);

  function GetDistributors() {
    distributorMasterService
      .GetDistributors(tableRequest)
      .then((response) => {
        const data = response;
        if (data && data.responseData && data.responseData.length > 0) {
          const sales = data.responseData.slice(0, tableRequest.PageSize);
          setStatee((prevData) => ({
            ...prevData,
            datasource: data.responseData,
            totalRecords: data.responseData[0].totalRows,
            sales,
            loading: false
          }));
        } else {
          setStatee((prevData) => ({
            ...prevData,
            datasource: [],
            totalRecords: 0,
            sales: [],
            loading: false
          }));
        }
      })
      .catch((error) => {
        console.error("API request failed:", error);
        toast.error("Failed to fetch data");
        setStatee((prevData) => ({
          ...prevData,
          loading: false
        }));
      });
  }

  const initialFormData = {
    SAPCustomerCode: "",
    distributorName: "",
    email: "",
    MobNo: "",
    password: "",
    Cpassword: "",
    country: "",
    state: "",
    city: "",
    address1: "",
    address2: "",
    pincode: "",
    lat: "",
    long: "",
    IsActive: true
  };

  const handleDialogClose = () => {
    setShowDialog(false);
    setFormData(initialFormData);
    setFormErrors({
      SAPCustomerCode: "",
      distributorName: "",
      email: "",
      MobNo: "",
      password: "",
      Cpassword: "",
      country: "",
      state: "",
      city: "",
      address1: "",
      address2: "",
      pincode: "",
      lat: "",
      long: ""
    });
  };

  const searchFilter = (e) => {
    const value = e.target.value;
    setStatee((prevData) => ({
      ...prevData,
      loading: false
    }));
    tableRequest.SearchValue = value;
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
    GetDistributors();
  };

  const getLazyLoadingValues = (event) => {
    setStatee((prevData) => ({
      ...prevData,
      first: event.first,
      rows: event.rows
    }));
    tableRequest.PageSize = event.rows;
    tableRequest.PageNo = Math.floor(event.first / event.rows) + 1;
    tableRequest.First = event.first + 1;
    tableRequest.IsActive = "1";
    tableRequest.SearchValue = tableRequest.SearchValue || "";
    tableRequest.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
  };

  const onSort = (event) => {
    setStatee((prevData) => ({
      ...prevData,
      sortOrder: state.sortOrder === 1 ? 2 : 1
    }));
    tableRequest.SortColumn = event.sortField;
    tableRequest.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
    GetDistributors();
  };

  const onPage = (event) => {
    setStatee((prevData) => ({
      ...prevData,
      loading: true
    }));
    getLazyLoadingValues(event);
    GetDistributors();
  };

  const header = (
    <div className="header-container p-4 bg-gray-100 rounded-lg shadow-md flex flex-col md:flex-row justify-between items-center">
      <div className="flex items-center mb-4 md:mb-0">
        <h1 className="reports_head text-2xl font-semibold text-gray-800 mr-4">
          Distributor Master
        </h1>
      </div>
      <div className="search-export-container flex items-center">
        <div className="search-container flex items-center mr-4">
          <InputText
            type="search"
            onInput={searchFilter}
            value={tableRequest.SearchValue || ""}
            placeholder="Global Search"
            size="22"
            className="p-inputtext-sm"
          />
        </div>
        <Button
          onClick={openDialog}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          type="button"
        >
          (+) Add Distributor
        </Button>
      </div>
    </div>
  );

  return (
    <div>
      {state.loading ? (
        <Loader />
      ) : (
        <div className="mt-3">
          <div className="container-fluid mt-3 mb-3">
            <div className="mt-3">
              <div className="container-fluid mt-3 mb-3">
                <DataTable
                  exportFilename="UserMaster"
                  responsive={true}
                  header={header}
                  globalFilter={state.globalFilter}
                  emptyMessage={state.emptyMessage}
                  value={state.sales}
                  paginator={true}
                  paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                  rows={state.rows}
                  rowsPerPageOptions={[10, 50, 200, 500]}
                  totalRecords={state.totalRecords}
                  lazy={true}
                  first={state.first}
                  onPage={onPage}
                  onSort={onSort}
                  className="p-datatable-responsive"
                >
                  <Column
                    field="distributorName"
                    header="Distributor Name"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                  <Column
                    field="sapCustomerCode"
                    header="SAP Customer Code"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                  <Column
                    field="mobileNo"
                    header="Mobile Number"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                  <Column
                    field="email"
                    header="Email"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                  <Column
                    field="stateName"
                    header="State"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                  <Column
                    field="cityName"
                    header="City"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                  <Column
                    field="formattedCreatedDate"
                    header="Created Date"
                    sortable={true}
                    style={{ width: "100px" }}
                  />
                  <Column
                    body={handleButtonClick}
                    header="Action"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                </DataTable>
              </div>
            </div>
          </div>

          <Dialog
            open={showDialog}
            onClose={handleDialogClose}
            PaperProps={{ style: { backgroundColor: "black" } }}
            className="add"
          >
            <DialogTitle style={{ color: "white", textAlign: "center" }}>
              {selectedRow ? "Update Distributor" : "Add Distributor"}
            </DialogTitle>
            <form onSubmit={handleFormSubmit}>
              <DialogContent>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <TextField
                      margin="dense"
                      label={
                        <span>
                          SAP Customer Code{" "}
                          <span className="text-red-500">*</span>
                        </span>
                      }
                      type="text"
                      name="SAPCustomerCode"
                      value={formData.SAPCustomerCode}
                      onChange={handleFormChange}
                      placeholder="Enter SAP Customer Code"
                      fullWidth
                      error={!!formErrors.SAPCustomerCode}
                      helperText={formErrors.SAPCustomerCode}
                    />
                    <TextField
                      margin="dense"
                      label={
                        <span>
                          Distributor Name{" "}
                          <span className="text-red-500">*</span>
                        </span>
                      }
                      type="text"
                      name="distributorName"
                      value={formData.distributorName}
                      onChange={handleFormChange}
                      placeholder="Enter Distributor Name"
                      fullWidth
                      error={!!formErrors.distributorName}
                      helperText={formErrors.distributorName}
                    />
                    <TextField
                      margin="dense"
                      label={
                        <span>
                          Email <span className="text-red-500">*</span>
                        </span>
                      }
                      type="text"
                      name="email"
                      value={formData.email}
                      onChange={handleFormChange}
                      placeholder="Enter Email"
                      fullWidth
                      error={!!formErrors.email}
                      helperText={formErrors.email}
                    />
                    <TextField
                      margin="dense"
                      label={
                        <span>
                          Mobile Number <span className="text-red-500">*</span>
                        </span>
                      }
                      type="text"
                      name="MobNo"
                      value={formData.MobNo}
                      onChange={handleFormChange}
                      placeholder="Enter Mobile No."
                      fullWidth
                      error={!!formErrors.MobNo}
                      helperText={formErrors.MobNo}
                    />
                    <TextField
                      margin="dense"
                      label={
                        <span>
                          Password <span className="text-red-500">*</span>
                        </span>
                      }
                      type="password"
                      name="password"
                      value={formData.password}
                      onChange={handleFormChange}
                      placeholder="Enter Password "
                      fullWidth
                      error={!!formErrors.password}
                      helperText={formErrors.password}
                    />
                    <TextField
                      margin="dense"
                      label={
                        <span>
                          Confirm Password{" "}
                          <span className="text-red-500">*</span>
                        </span>
                      }
                      type="password"
                      name="Cpassword"
                      value={formData.Cpassword}
                      onChange={handleFormChange}
                      placeholder="Enter Confirm password"
                      fullWidth
                      error={!!formErrors.Cpassword}
                      helperText={formErrors.Cpassword}
                    />
                    <TextField
                      margin="dense"
                      label={<span>Latitude</span>}
                      type="text"
                      name="lat"
                      value={formData.lat}
                      onChange={handleFormChange}
                      placeholder="Enter Latitude"
                      fullWidth
                      error={!!formErrors.lat}
                      helperText={formErrors.lat}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <FormControl
                      fullWidth
                      margin="dense"
                      error={!!formErrors.country}
                    >
                      <InputLabel id="countryDropdown">
                        <span>
                          Country <span className="text-red-500">*</span>
                        </span>
                      </InputLabel>
                      <Select
                        labelId="countryDropdown"
                        value={formData.country}
                        name="country"
                        onChange={handleFormChange}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: 300
                            }
                          }
                        }}
                      >
                        <MenuItem value="101">India</MenuItem>
                      </Select>
                      {!!formErrors.country && (
                        <FormHelperText>{formErrors.country}</FormHelperText>
                      )}
                    </FormControl>

                    <FormControl
                      fullWidth
                      margin="dense"
                      error={!!formErrors.state}
                    >
                      <InputLabel id="stateDropdown">
                        <span>
                          State <span className="text-red-500">*</span>
                        </span>
                      </InputLabel>
                      <Select
                        labelId="stateDropdown"
                        value={formData.state}
                        name="state"
                        onChange={handleFormChange}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: 300
                            }
                          }
                        }}
                      >
                        {states.map((state) => (
                          <MenuItem key={state.stateId} value={state.stateId}>
                            {state.state}
                          </MenuItem>
                        ))}
                      </Select>
                      {!!formErrors.state && (
                        <FormHelperText>{formErrors.state}</FormHelperText>
                      )}
                    </FormControl>
                    <FormControl
                      fullWidth
                      margin="dense"
                      error={!!formErrors.city}
                    >
                      <InputLabel id="cityDropdown">
                        <span>
                          City <span className="text-red-500">*</span>
                        </span>
                      </InputLabel>
                      <Select
                        labelId="cityDropdown"
                        value={formData.city}
                        name="city"
                        onChange={handleFormChange}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: 300
                            }
                          }
                        }}
                      >
                        {cities.map((city) => (
                          <MenuItem key={city.cityId} value={city.cityId}>
                            {city.city}
                          </MenuItem>
                        ))}
                      </Select>
                      {!!formErrors.city && (
                        <FormHelperText>{formErrors.city}</FormHelperText>
                      )}
                    </FormControl>
                    <TextField
                      margin="dense"
                      label={
                        <span>
                          Address 1 <span className="text-red-500">*</span>
                        </span>
                      }
                      type="text"
                      name="address1"
                      value={formData.address1}
                      onChange={handleFormChange}
                      placeholder="Enter Address"
                      fullWidth
                      error={!!formErrors.address1}
                      helperText={formErrors.address1}
                    />
                    <TextField
                      margin="dense"
                      label={
                        <span>
                          Address 2 <span className="text-red-500">*</span>
                        </span>
                      }
                      type="text"
                      name="address2"
                      value={formData.address2}
                      onChange={handleFormChange}
                      placeholder="Enter Address"
                      fullWidth
                      error={!!formErrors.address2}
                      helperText={formErrors.address2}
                    />
                    <TextField
                      margin="dense"
                      label={
                        <span>
                          Pincode <span className="text-red-500">*</span>
                        </span>
                      }
                      type="text"
                      name="pincode"
                      value={formData.pincode}
                      onChange={handleFormChange}
                      placeholder="Enter pincode"
                      fullWidth
                      error={!!formErrors.pincode}
                      helperText={formErrors.pincode}
                    />
                    <TextField
                      margin="dense"
                      label={<span>Longitude</span>}
                      type="text"
                      name="long"
                      value={formData.long}
                      onChange={handleFormChange}
                      placeholder="Enter Longitude"
                      fullWidth
                      error={!!formErrors.long}
                      helperText={formErrors.long}
                    />
                  </Grid>
                </Grid>
                <div className="row">
                  <div className="col-md-6">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={formData.IsActive}
                          onChange={handleFormChange}
                          name="IsActive"
                          color="primary"
                        />
                      }
                      label="Active"
                      error={!!formErrors.IsActive}
                      helperText={formErrors.IsActive}
                    />
                  </div>
                  <div className="col-md-6">
                    <DialogActions>
                      <Button
                        onClick={handleDialogClose}
                        className="can bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        type="button"
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        color="primary"
                        className="sub bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                      >
                        Submit
                      </Button>
                    </DialogActions>
                  </div>
                </div>
              </DialogContent>
            </form>
          </Dialog>
        </div>
      )}
    </div>
  );
};
export default DistributorMaster;